import { action } from 'typesafe-actions'
import { Tariff } from 'store/common/types'
import { SubscriptionActionTypes } from './types'

export const fetchRequest = () => action(SubscriptionActionTypes.FETCH_REQUEST)
export const fetchSuccess = (data: Tariff) => action(SubscriptionActionTypes.FETCH_SUCCESS, data)
export const fetchError = (message: string) => action(SubscriptionActionTypes.FETCH_ERROR, message)

export const tariffLinkOpened = () => action(SubscriptionActionTypes.TARIFF_LINK_OPENED)
